import * as React from "react";
import "./notification.scss";
import {ReactComponent as IconError} from "../../../../statics/icons/icon_error.svg";
import {ReactComponent as IconWarning} from "../../../../statics/icons/icon_warning.svg";
import {ReactComponent as IconSuccess} from "../../../../statics/icons/icon_success.svg";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

interface NotificationProps {
    message: string | React.ReactNode;
    type: "error" | "warning" | "success";
    onClose: () => void;
}

export default function Notification(props: NotificationProps) {
    return (
        <Snackbar className={`notification notification-with-${props.type}`} open={true}>
            <Alert
                severity={props.type}
                onClose={props.onClose}
                className={props.type}
                iconMapping={{
                    error: <IconError/>,
                    warning: <IconWarning/>,
                    success: <IconSuccess/>
                }}
            >
                {props.message}
            </Alert>
        </Snackbar>
    );
}
